if (!customElements.get('aurlona-page-form')) {
  customElements.define('aurlona-page-form', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.enhanceCustomForm();
      this.addEventListener('change', event => {
        const input = event.target;
        if (!input.matches('[data-page-files]')) return;
        const files = Array.from(input.files || []);
        const output = input.parentElement.querySelector('[data-file-list]');
        input.setCustomValidity(files.length > 5 ? 'Please choose no more than 5 images.' : '');
        output.textContent = files.length ? `Selected: ${files.map(file => file.name).join(', ')}` : '';
        if (files.length > 5) input.reportValidity();
      }, {signal: this.events.signal});
    }
    enhanceCustomForm() {
      const root = this.querySelector('[data-forms-id="forms-root-1168677"]');
      if (!root) return;
      this.formObserver?.disconnect();
      clearInterval(this.formPoll);
      clearTimeout(this.countryTimer);
      this.phoneDone = false;
      this.phoneOpened = false;
      let region;
      try {
        region = new Intl.Locale(navigator.language).region;
      } catch {}
      const fieldName = 'custom#describe_your_painting_and_space';
      const protectPhone = event => {
        if (event.isTrusted && event.composedPath().some(node =>
          node.matches?.('#phone_number, .phone-country-selector')
        )) {
          this.phoneDone = true;
          clearTimeout(this.countryTimer);
        }
      };
      for (const type of ['pointerdown', 'keydown', 'input']) {
        root.addEventListener(type, protectPhone, {capture: true, signal: this.events.signal});
      }
      const enhance = shadow => {
        const message = shadow.querySelector('textarea[name="' + fieldName + '"]');
        const label = shadow.getElementById('label-' + fieldName);
        if (message && label) {
          if (!message.id) message.id = label.htmlFor;
          if (!message.hasAttribute('aria-labelledby')) {
            message.setAttribute('aria-labelledby', label.id);
          }
        }
        if (this.phoneDone || !/^[A-Z]{2}$/.test(region || '')) return;
        const phone = shadow.getElementById('phone_number');
        const toggle = shadow.querySelector('.phone-country-selector button');
        if (!phone || !toggle) return;
        const currentCode = toggle.getAttribute('aria-label')?.match(/\+\d+$/)?.[0];
        if (phone.value.trim() && phone.value.trim() !== currentCode) {
          this.phoneDone = true;
          return;
        }
        const currentRegion = toggle.querySelector('img')?.getAttribute('src')?.match(/\/([a-z]{2})\.svg(?:\?|$)/i)?.[1];
        if (currentRegion?.toUpperCase() === region) {
          this.phoneDone = true;
          return;
        }
        if (this.phoneOpened) {
          const option = shadow.getElementById('select-country-' + region);
          if (option) {
            this.phoneDone = true;
            clearTimeout(this.countryTimer);
            option.click();
          }
          return;
        }
        if (toggle.getAttribute('aria-expanded') === 'true' || shadow.activeElement === phone) {
          this.phoneDone = true;
          return;
        }
        this.phoneOpened = true;
        toggle.click();
        this.countryTimer = setTimeout(() => {
          if (!this.phoneDone && toggle.getAttribute('aria-expanded') === 'true') toggle.click();
          this.phoneDone = true;
        }, 1000);
      };
      let attempts = 0;
      const connect = () => {
        const shadow = root.querySelector('shopify-forms-embed')?.shadowRoot;
        if (shadow) {
          clearInterval(this.formPoll);
          this.formObserver = new MutationObserver(() => enhance(shadow));
          this.formObserver.observe(shadow, {childList: true, subtree: true});
          enhance(shadow);
        } else if (++attempts >= 120) {
          clearInterval(this.formPoll);
        }
      };
      this.formPoll = setInterval(connect, 250);
      connect();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.formObserver?.disconnect();
      clearInterval(this.formPoll);
      clearTimeout(this.countryTimer);
    }
  });
}
